import { css } from "@linaria/core";

import { verticalMarginMixin } from "../../../styles/mixins/collapsableMargin";
import { boundaryPaddingProp } from "../../../styles/variables";

export const boundaryCls = css`
  ${verticalMarginMixin("3rem")};
  --desired-width: 69rem;

  margin-inline: auto;
  padding: 0 var(${boundaryPaddingProp});

  box-sizing: border-box;
  max-width: 100%;
  width: calc(var(--desired-width) + var(${boundaryPaddingProp}) * 2);
`;
